// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCdiSource = objectOf({
  id: string,
  name: maybe(string, true),
  data_warehouse_type: string,
  created_at: maybe(string, true),
  updated_at: maybe(string, true),
});

export const isCdiSourcesResult = arrayOf(isCdiSource);

export const isPostIntegrationsDirectCdiSourcesResult = isCdiSource;
